import { gql } from "@apollo/client";

export default gql`
  mutation SendInvites($targetType: String!, $targetId: String!, $emails: [String]) {
    sendInvites(targetType: $targetType, targetId: $targetId, emails: $emails)
  }
`;
